export const CONSENT_DEFINITIONS = {
  // Translations are avaibale only for fcra_capture_consent and fcra_batch_consent keys rest are TODO for later as we dont have them yet
  fcra_standard: {
    id: 'fcra_standard',
    activeVersion: 'v1',
  },
  fcra_capture_consent: {
    id: 'fcra_capture_consent',
    activeVersion: 'v1',
  },
  fcra_post_order_pre_fulfillment_consent: {
    id: 'fcra_post_order_pre_fulfillment_consent',
    activeVersion: 'v1',
  },
  fcra_batch_consent: {
    id: 'fcra_batch_consent',
    activeVersion: 'v1',
  },
  fcra_multiparty_consent: {
    id: 'fcra_multiparty_consent',
    activeVersion: 'v1',
  },
};
